import { ObjectUtil } from 'app/utils/object.util';
import { NoUnderscorePipe } from 'app/shared/pipes/no-underscore/no-underscore.pipe';

export class PerformanceFacts {
  /* eslint-disable */
  actual_power: number;
  theoretical_power: number;
  rated_power: number;
  power_loss: number;
  WTUR1_per_loadFactor: number;
  WTUR1_per_efficiency?: number;
  noEfficiency?: boolean;
  fe_name?: string;
  availableSignalCount?: number;
  totalSignalCount?: number;
  LPHD1_PhyHealth_stVal?: number;
  WTUR1_status?: number;
  serialNav?: number;
  dataAquisitionMax?: number;
  turbines?: any;
  WTUR1_TurSt_actSt_stVal?: number;
  WNAC1_WdSpd_mag_f?: number;
  /* eslint-enable */

  static mapFromPortfolio(portfolio: any) {
    if (portfolio) {
      return new PerformanceFacts({
        actual_power: portfolio.data.WTUR1_MW_mag_f.sum,
        theoretical_power: portfolio.data.WTUR1_MW_theoretical.sum,
        rated_power: portfolio.dataDebbug.WTUR1_MW_rated.sum,
        power_loss: portfolio.data.WTUR1_MW_loss.sum,
        WTUR1_per_loadFactor: portfolio.data.WTUR1_per_loadFactor.avg,
        availableSignalCount: portfolio.availableSignalCount,
        totalSignalCount: portfolio.totalSignalCount,
        dataAquisitionMax: Math.min(new Date().getTime(), portfolio.metaData.dataAquisitionMax.unixTimestamp),
        noEfficiency: true
      });
    } else {
      return null;
    }
  }

  static mapFromPark(park: any) {
    if (park) {
      return new PerformanceFacts({
        fe_name: park.fe_name,
        actual_power: park.data.WTUR1_MW_mag_f.sum,
        theoretical_power: park.data.WTUR1_MW_theoretical.sum,
        rated_power: park.dataDebbug.WTUR1_MW_rated.sum,
        power_loss: park.data.WTUR1_MW_loss.sum,
        WTUR1_per_loadFactor: park.data.WTUR1_per_loadFactor.avg,
        WTUR1_per_efficiency: park.data.WTUR1_per_efficiency.avg,
        availableSignalCount: park.availableSignalCount,
        totalSignalCount: park.totalSignalCount,
        dataAquisitionMax: Math.min(new Date().getTime(), park.metaData.dataAquisitionMax.unixTimestamp)
      });
    } else {
      return null;
    }
  }

  static mapFromTurbine(turbine: any) {
    if (turbine) {
      return new PerformanceFacts({
        fe_name: new NoUnderscorePipe().transform(turbine.code) + ' (' + turbine.serialNav + ')',
        actual_power: ObjectUtil.getProperty(turbine, 'data.WTUR1_kW_mag_f', null),
        theoretical_power: ObjectUtil.getProperty(turbine, 'data.WTUR1_kW_theoretical', null),
        rated_power: ObjectUtil.getProperty(turbine, 'dataDebbug.WTUR1_kW_rated', null),
        power_loss: ObjectUtil.getProperty(turbine, 'data.WTUR1_kW_loss', null),
        WTUR1_per_loadFactor: ObjectUtil.getProperty(turbine, 'data.WTUR1_per_loadFactor', null),
        WTUR1_per_efficiency: ObjectUtil.getProperty(turbine, 'data.WTUR1_per_efficiency', null),
        LPHD1_PhyHealth_stVal: ObjectUtil.getProperty(turbine, 'data.LPHD1_PhyHealth_stVal', null),
        WTUR1_TurSt_actSt_stVal: ObjectUtil.getProperty(turbine, 'data.WTUR1_TurSt_actSt_stVal', null),
        WTUR1_status: ObjectUtil.getProperty(turbine, 'data.WTUR1_status', null),
        WNAC1_WdSpd_mag_f: ObjectUtil.getProperty(turbine, 'data.WNAC1_WdSpd_mag_f', null),
        serialNav: turbine.serialNav,
        turbines: this.generateOptions(turbine.park.turbines, turbine)
      });
    } else {
      return null;
    }
  }

  static generateOptions(turbines: [], turbine: any): any[] {
    const sorted = turbines.sort((a: any, b: any) => a.code.localeCompare(b.code, undefined, { numeric: true, sensitivity: 'base' }));
    const index = sorted.findIndex((s: any) => s.code === turbine.code);
    sorted.unshift(sorted.splice(index, 1)[0]);
    return sorted.map((t: any) => Object.assign({
      label: new NoUnderscorePipe().transform(t.code) + ' (' + t.serialNav + ')',
      serial: t.serialNav
    }));
  }

  constructor(init: Partial<PerformanceFacts>) {
    Object.assign(this, init);
  }

}
